let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("er85J")).then(() => parcelRequire('eipTf'));